import { ThreeRow } from "../../core/layouts";
import { Text, Divider, Select, Input } from "react_reusable_components";
import { customInputStyle } from "../CustomInput/CustomInput";
import variables from "../../themes/base/styles/variables";
import { NumericFormat } from "react-number-format";
import "./CustomMobile.scss";

const mobileInputStyle = {
  inputStyle: {
    color: variables.textDefault,
    fontSize: variables.fontSizeNormal,
  },
  input:{
    height: variables.fullHeight,
    border: "none",
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
  }
};

export default function CustomMobileInput({
  style,
  value,
  onChange,
  className,
  placeholder,
  label,
  labelProps,
  isPassword,
  required,
  error,
  size,
  countryCodes,
  options,
  name,
  showStar,
  setCountryCodeValue,
  countryCodeValue,
  disabled,
  countryCodeName,
  valueCountryCode,
  handleChangeCountryCode,
  onBlur,
  ...props
}) {
  return (
    <ThreeRow
      style={{ overflow: "unset" }}
      topSection={
        label && (
          <Text style={customInputStyle.labelStyle}>
            {label}
            {required && (
              <Text style={customInputStyle.requiredStyle}>
                &nbsp;{showStar && "*"}
              </Text>
            )}
          </Text>
        )
      }
      middleSection={
        <div className="phone-input-container">
          <div className="mobile-input-select">
            <Select
              options={options}
              onChange={handleChangeCountryCode}
              dropdownStyle={{ minWidth: "200px" }}
              dropdownClassName="custom-mobile-dropdown"
              value={valueCountryCode}
              name={countryCodeName}
              className={"select-code-style"}
              optionLabelProp={"value"}
            />
          </div>

          <Divider className="divider-style" type="vertical" />
          <NumericFormat
            customInput={Input}
            onChange={onChange}
            type="tel"
            style={mobileInputStyle.input}
            placeholder={placeholder}
            value={value}
            className="input-style"
            onBlur={onBlur}
            allowLeadingZeros
          />
        </div>
      }
      bottomSection={
        !!error && (
          <Text style={customInputStyle.errorStyle} type="danger">
            {error}
          </Text>
        )
      }
    />
  );
}
